import HighlightIcon from '@/components2/HighlightIcon';
import React, { Fragment } from 'react';

export default function WithShuttles({
  highlights,
  facility,
  size = null,
  ...props
}) {
  const checkedHighlights = highlights.filter((highlight) => highlight.check);
  return (
    <>
      <div
        className="flex flex-col gap-3 justify-center items-start md:bg-transparent bg-gray-50 mb-4 md:mb-0 p-2 md:p-0"
        {...props}
      >
        {checkedHighlights.map((highlight, index) => (
          <Fragment key={highlight.type + index}>
            {highlight.type === 'facility_shuttle_frequency' && (
              <div className="flex flex-row justify-start items-center ">
                <HighlightIcon
                  type="shuttle"
                  width={33}
                  height={33}
                  fill="#434343"
                />
                <p
                  className={`text-base text-left ml-2 flex flex-col gap-1 justify-center items-start`}
                >
                  <span className="font-bold">
                    Shuttle Frequency
                    {highlight.description && (
                      <span className="font-normal">
                        {' '}
                        - {highlight.description}
                      </span>
                    )}
                  </span>
                </p>
              </div>
            )}
            {highlight.type === 'facility_free_shuttles' && (
              <div className="flex flex-row justify-start items-center ">
                <HighlightIcon
                  type="free-shuttle"
                  width={33}
                  height={33}
                  fill="#434343"
                />
                <p
                  className={`text-base text-left ml-2 flex flex-col gap-1 justify-center items-start`}
                >
                  <span className="font-bold">
                    Free Shuttle
                    {highlight.description && (
                      <span className="font-normal">
                        {' '}
                        - {highlight.description}
                      </span>
                    )}
                  </span>
                </p>
              </div>
            )}
            {highlight.type === 'facility_no_shuttles' && (
              <div className="flex flex-row justify-start items-center ">
                <HighlightIcon
                  type="no-free-shuttle"
                  width={33}
                  height={33}
                  fill="#434343"
                />
                <p
                  className={`text-base text-left ml-2 flex flex-col lg:flex-row gap-1 lg:gap-2 justify-center items-start`}
                >
                  <span className="font-bold">
                    No Shuttle
                    {highlight.description && (
                      <span className="font-normal">
                        {' '}
                        - {highlight.description}
                      </span>
                    )}
                  </span>
                </p>
              </div>
            )}
          </Fragment>
        ))}
      </div>
    </>
  );
}
